import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
// import { VivaInputModule } from 'src/app/controls/viva-input/viva-input.module';
// import { VivaTextAreaModule } from '../controls/viva-text-area/viva-text-area.module';
// import { VivaSelectModule } from '../controls/viva-select/viva-select.module';
// import { VivaToggleModule } from '../controls/viva-toggle/viva-toggle.module';
// import { VivaDateInputModule } from '../controls/viva-date-input/viva-date-input.module';
// import { VivaSpinnerModule } from '../controls/viva-spinner/viva-spinner.module';
import { PopupModule } from '../controls/pop-up/popup.module';
import { UsPhoneFormatPipe } from '../pipes/us-phone-format.pipe';
import { UsPhoneFormatDirective } from './directives/us-phone-format.directive';

// AG GRID 33 UPDATES
import { ModuleRegistry, TooltipModule, InfiniteRowModelModule, ValidationModule, TextFilterModule, PaginationModule, ClientSideRowModelModule, CustomFilterModule, DateFilterModule, LocaleModule, NumberFilterModule, RowSelectionModule, CsvExportModule } from 'ag-grid-community';
ModuleRegistry.registerModules([
	PaginationModule,
	InfiniteRowModelModule,
	ValidationModule,
	TextFilterModule,
	NumberFilterModule,
	DateFilterModule,
	CustomFilterModule,
	LocaleModule,
	RowSelectionModule,
	ClientSideRowModelModule,
	TooltipModule,
	CsvExportModule,
]);

@NgModule({
	declarations: [UsPhoneFormatPipe, UsPhoneFormatDirective],
	imports: [
		CommonModule,
		RouterModule,
		IonicModule,
		FormsModule,
		TranslateModule,
		// VivaInputModule,
		// VivaToggleModule,
		// VivaSelectModule,
		// VivaDateInputModule,
		// VivaSpinnerModule,
		// VivaTextAreaModule,
		PopupModule
	],
	exports: [
		FormsModule,
		TranslateModule,
		UsPhoneFormatPipe,
		UsPhoneFormatDirective,
		// VivaInputModule,
		// VivaToggleModule,
		// VivaSelectModule,
		// VivaDateInputModule,
		// VivaSpinnerModule,
		// VivaTextAreaModule,
		PopupModule
	],
})
export class SharedModule { }